import styled from "styled-components";

export const GamesOpenSessionRecordDefaultBox = styled.div`
    --open-session-record-padding: 6px;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: var(--open-session-record-padding);
    background-color: ${props => props.theme.components.gamingHistory.colors.recordBackground};
    border-radius: 4px;
`